webpackJsonp([35783957827783],{

/***/ 519:
/***/ (function(module, exports, __webpack_require__) {

	module.exports = __webpack_require__.p + "static/cloud.55e5939f.jpg";

/***/ }),

/***/ 520:
/***/ (function(module, exports, __webpack_require__) {

	module.exports = __webpack_require__.p + "static/design.b6631280.jpg";

/***/ }),

/***/ 523:
/***/ (function(module, exports, __webpack_require__) {

	module.exports = __webpack_require__.p + "static/digital.31caff1c.jpg";

/***/ }),

/***/ 525:
/***/ (function(module, exports, __webpack_require__) {

	module.exports = __webpack_require__.p + "static/eCommerce.7909e8fb.jpg";

/***/ }),

/***/ 527:
/***/ (function(module, exports, __webpack_require__) {

	module.exports = __webpack_require__.p + "static/elev8_seo.072ab90e.jpg";

/***/ }),

/***/ 528:
/***/ (function(module, exports, __webpack_require__) {

	module.exports = __webpack_require__.p + "static/elev8_web_design.62f60124.png";

/***/ }),

/***/ 534:
/***/ (function(module, exports, __webpack_require__) {

	module.exports = __webpack_require__.p + "static/social.af00061e.jpg";

/***/ }),

/***/ 209:
/***/ (function(module, exports, __webpack_require__) {

	"use strict";
	
	exports.__esModule = true;
	
	var _react = __webpack_require__(1);
	
	var _react2 = _interopRequireDefault(_react);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	var Banner = function Banner(props) {
	    return _react2.default.createElement(
	        "section",
	        { id: "banner", className: "major" },
	        _react2.default.createElement(
	            "div",
	            { className: "inner" },
	            _react2.default.createElement(
	                "header",
	                { className: "major" },
	                _react2.default.createElement(
	                    "h1",
	                    null,
	                    "Make digital work for your business"
	                )
	            ),
	            _react2.default.createElement(
	                "div",
	                { className: "content" },
	                _react2.default.createElement(
	                    "p",
	                    null,
	                    "Leverage the power of digital technology to increase your sales and improve your bottom line."
	                ),
	                _react2.default.createElement(
	                    "ul",
	                    { className: "actions" },
	                    _react2.default.createElement(
	                        "li",
	                        null,
	                        _react2.default.createElement(
	                            "a",
	                            { href: "#one", className: "button next scrolly" },
	                            "Get Started"
	                        )
	                    )
	                )
	            )
	        )
	    );
	};
	
	exports.default = Banner;
	module.exports = exports["default"];

/***/ }),

/***/ 221:
/***/ (function(module, exports, __webpack_require__) {

	'use strict';
	
	exports.__esModule = true;
	exports.pageQuery = undefined;
	
	var _react = __webpack_require__(1);
	
	var _react2 = _interopRequireDefault(_react);
	
	var _gatsbyLink = __webpack_require__(10);
	
	var _gatsbyLink2 = _interopRequireDefault(_gatsbyLink);
	
	var _reactHelmet = __webpack_require__(13);
	
	var _reactHelmet2 = _interopRequireDefault(_reactHelmet);
	
	var _Banner = __webpack_require__(209);
	
	var _Banner2 = _interopRequireDefault(_Banner);
	
	var _elev8_seo = __webpack_require__(527);
	
	var _elev8_seo2 = _interopRequireDefault(_elev8_seo);
	
	var _social = __webpack_require__(534);
	
	var _social2 = _interopRequireDefault(_social);
	
	var _elev8_web_design = __webpack_require__(528);
	
	var _elev8_web_design2 = _interopRequireDefault(_elev8_web_design);
	
	var _eCommerce = __webpack_require__(525);
	
	var _eCommerce2 = _interopRequireDefault(_eCommerce);
	
	var _cloud = __webpack_require__(519);
	
	var _cloud2 = _interopRequireDefault(_cloud);
	
	var _digital = __webpack_require__(523);
	
	var _digital2 = _interopRequireDefault(_digital);
	
	var _design = __webpack_require__(520);
	
	var _design2 = _interopRequireDefault(_design);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }
	
	function _possibleConstructorReturn(self, call) { if (!self) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return call && (typeof call === "object" || typeof call === "function") ? call : self; }
	
	function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function, not " + typeof superClass); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, enumerable: false, writable: true, configurable: true } }); if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass; }
	
	var HomeIndex = function (_React$Component) {
	    _inherits(HomeIndex, _React$Component);
	
	    function HomeIndex() {
	        _classCallCheck(this, HomeIndex);
	
	        return _possibleConstructorReturn(this, _React$Component.apply(this, arguments));
	    }
	
	    HomeIndex.prototype.render = function render() {
	        var siteTitle = this.props.data.site.siteMetadata.title;
	        var siteDescription = this.props.data.site.siteMetadata.description;
	
	        return _react2.default.createElement(
	            'div',
	            null,
	            _react2.default.createElement(
	                _reactHelmet2.default,
	                null,
	                _react2.default.createElement(
	                    'title',
	                    null,
	                    siteTitle
	                ),
	                _react2.default.createElement('meta', { name: 'description', content: siteDescription })
	            ),
	            _react2.default.createElement(_Banner2.default, null),
	            _react2.default.createElement(
	                'div',
	                { id: 'main' },
	                _react2.default.createElement(
	                    'section',
	                    { id: 'one', className: 'tiles' },
	                    _react2.default.createElement(
	                        'article',
	                        { style: { backgroundImage: 'url(' + _design2.default + ')' } },
	                        _react2.default.createElement(
	                            'header',
	                            { className: 'major' },
	                            _react2.default.createElement(
	                                'h3',
	                                null,
	                                'Web Design & Development'
	                            ),
	                            _react2.default.createElement(
	                                'p',
	                                null,
	                                'We build websites & experiences that perfectly communicate your business vision.'
	                            )
	                        ),
	                        _react2.default.createElement(_gatsbyLink2.default, { to: '/design', className: 'link primary' })
	                    ),
	                    _react2.default.createElement(
	                        'article',
	                        { style: { backgroundImage: 'url(' + _social2.default + ')' } },
	                        _react2.default.createElement(
	                            'header',
	                            { className: 'major' },
	                            _react2.default.createElement(
	                                'h3',
	                                null,
	                                'Social Media Management'
	                            ),
	                            _react2.default.createElement(
	                                'p',
	                                null,
	                                'We manage your social media presence professionally, so you gain exposure and generate sales.'
	                            )
	                        ),
	                        _react2.default.createElement(_gatsbyLink2.default, { to: '/social', className: 'link primary' })
	                    ),
	                    _react2.default.createElement(
	                        'article',
	                        { style: { backgroundImage: 'url(' + _elev8_seo2.default + ')' } },
	                        _react2.default.createElement(
	                            'header',
	                            { className: 'major' },
	                            _react2.default.createElement(
	                                'h3',
	                                null,
	                                'Search Engine Optimization'
	                            ),
	                            _react2.default.createElement(
	                                'p',
	                                null,
	                                'Get high-conversion leads for your business.'
	                            )
	                        ),
	                        _react2.default.createElement(_gatsbyLink2.default, { to: '/seo', className: 'link primary' })
	                    ),
	                    _react2.default.createElement(
	                        'article',
	                        { style: { backgroundImage: 'url(' + _eCommerce2.default + ')' } },
	                        _react2.default.createElement(
	                            'header',
	                            { className: 'major' },
	                            _react2.default.createElement(
	                                'h3',
	                                null,
	                                'eCommerce Solutions'
	                            ),
	                            _react2.default.createElement(
	                                'p',
	                                null,
	                                'We help you sell your products and services online.'
	                            )
	                        ),
	                        _react2.default.createElement(_gatsbyLink2.default, { to: '/eCommerce', className: 'link primary' })
	                    ),
	                    _react2.default.createElement(
	                        'article',
	                        { style: { backgroundImage: 'url(' + _cloud2.default + ')' } },
	                        _react2.default.createElement(
	                            'header',
	                            { className: 'major' },
	                            _react2.default.createElement(
	                                'h3',
	                                null,
	                                'Application Development'
	                            ),
	                            _react2.default.createElement(
	                                'p',
	                                null,
	                                'We develop solutions that just work.'
	                            )
	                        ),
	                        _react2.default.createElement(_gatsbyLink2.default, { to: '/development', className: 'link primary' })
	                    ),
	                    _react2.default.createElement(
	                        'article',
	                        { style: { backgroundImage: 'url(' + _digital2.default + ')' } },
	                        _react2.default.createElement(
	                            'header',
	                            { className: 'major' },
	                            _react2.default.createElement(
	                                'h3',
	                                null,
	                                'Digital Consulting'
	                            ),
	                            _react2.default.createElement(
	                                'p',
	                                null,
	                                'We help your business make the right decisions.'
	                            )
	                        ),
	                        _react2.default.createElement(_gatsbyLink2.default, { to: '/consulting', className: 'link primary' })
	                    )
	                ),
	                _react2.default.createElement(
	                    'section',
	                    { id: 'two' },
	                    _react2.default.createElement(
	                        'div',
	                        { className: 'inner' },
	                        _react2.default.createElement(
	                            'header',
	                            { className: 'major' },
	                            _react2.default.createElement(
	                                'h2',
	                                null,
	                                'About'
	                            )
	                        ),
	                        _react2.default.createElement(
	                            'p',
	                            null,
	                            'We are a full-service digital marketing agency providing SEO services, social media management, PPC, web design, and creative solutions that boost your business! We develop websites, social media campaigns, and brands from scratch.'
	                        ),
	                        _react2.default.createElement(
	                            'p',
	                            null,
	                            'There are lots of ways to get yourself online nowadays with lots of talented people looking to help you out. We like to think we at elev8.it are different. If you\u2019re looking for a partner that offers a full range of digital marketing services that helps your brand grow online, lets you take control of your marketing efforts, and improves your conversion rate, you\u2019ve come to the right place.'
	                        ),
	                        _react2.default.createElement(
	                            'p',
	                            null,
	                            'We take care of all your digital marketing needs while you focus on what you do best \u2013 adding value through your business. We meet your technological, advertising, and online marketing needs by creating and maintaining web design, marketing, and digital identity solutions that work for your business. We are there for you long after your website is up and running in order to make sure our creative and cost-effective solutions work for your target market and bring you profitable leads.'
	                        ),
	                        _react2.default.createElement(
	                            'ul',
	                            { className: 'actions' },
	                            _react2.default.createElement(
	                                'li',
	                                null,
	                                _react2.default.createElement(
	                                    _gatsbyLink2.default,
	                                    { to: '/portfolio', className: 'button' },
	                                    'Portfolio'
	                                )
	                            ),
	                            _react2.default.createElement(
	                                'li',
	                                null,
	                                _react2.default.createElement(
	                                    _gatsbyLink2.default,
	                                    { to: '/team', className: 'button special' },
	                                    'Team'
	                                )
	                            )
	                        )
	                    )
	                )
	            )
	        );
	    };
	
	    return HomeIndex;
	}(_react2.default.Component);
	
	exports.default = HomeIndex;
	var pageQuery = exports.pageQuery = '** extracted graphql fragment **';

/***/ })

});


// WEBPACK FOOTER //
// component---src-pages-index-js-51d9c41618ea280e01b6.js